<template lang="pug">
  span
    h1 Líneas de emergencia
    p {{data[1].text}}
    h2 Líneas nacionales
    .espacio
    a(href="tel:123").rosa Llama al 123
    .espacio
  
</template>
<script>
import Modal from "@/components/Modal" 
export default {
  name: 'Lineas de emergencia',
  components: {
    Modal
  },
  props: ['visible', 'data'],
  model: {
    prop: 'visible'
  },
  watch: {
    visible(){
      // Si el prop "Visible" es falso, entonces emita al parent visibel = falso
      !this.visible && this.$emit('update:visible', false)
    }
  }
}
</script>
<style lang="sass">
.orientacion
  section
    font-size: .9em
    padding: 1.3em 0
    border-bottom: 1px solid lightgrey 

  h2 
    color: #4b2e83
    text-transform: uppercase
    font-size: 1em
    line-height: 2.6em
    border-bottom: 3px solid #4b2e83
  h3 
    font-size: 1em
  .rosa
    background: #f5f1fe
    color: #4b2e83
    border-radius: 4px
    padding: 12px
    position: relative
    display: block
    text-decoration: none
    &::after
      content: "📞"
      position: absolute
      right: 12px
  .espacio
    height: 2em  
</style>